<template>
	<div>
		<div class="container-fluid main position-relative"></div>
		<div class="container padding80" id="services">
			<div class="row">
				<div class="col-12 text-center">
					<h2 class="abril font-40 margin-b-40">{{ $t("services.title") }}</h2>
				</div>
			</div>
			<div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
				<div v-bind:class=" isMobile ? 'carousel-inner':'row'">
					<div v-bind:class=" isMobile ? 'carousel-item active':'col-12 col-md-6 position-relative padding5'">
						<img src="../assets/img/packaging.jpg" draggable="false" class="img-fluid">
						<div class="service-container text-white text-center">
							<div class="service-text">
								<h2 class="abril">{{ $t("services.branding_title") }}</h2>
								<p>{{ $t("services.branding_text") }}</p>
								<a href="#branding" class="border-link text-white white-border btn-animation">{{ $t("services.more") }}</a>
							</div>
						</div>
					</div>
					<div v-bind:class=" isMobile ? 'carousel-item':'col-12 col-md-6 position-relative padding5'">
						<img src="../assets/img/movie.jpg" draggable="false" class="img-fluid">
						<div class="service-container text-white text-center">
							<div class="service-text">
								<h2 class="abril">{{ $t("services.movie_title") }}</h2>
								<p>{{ $t("services.movie_text") }}<br>{{ $t("services.movie_text2") }}</p>
								<a href="#movie" class="border-link text-white white-border btn-animation">{{ $t("services.more") }}</a>
							</div>
						</div>
					</div>
					<div v-bind:class=" isMobile ? 'carousel-item':'col-12 col-md-6 position-relative padding5'">
						<img src="../assets/img/social.jpg" draggable="false" class="img-fluid">
						<div class="service-container text-white text-center">
							<div class="service-text">
								<h2 class="abril">{{ $t("services.social_title") }}</h2>
								<p>{{ $t("services.social_text") }}<br>{{ $t("services.social_text2") }}</p>
								<a href="#social" class="border-link text-white white-border btn-animation">{{ $t("services.more") }}</a>
							</div>
						</div>
					</div>
					<div v-bind:class=" isMobile ? 'carousel-item':'col-12 col-md-6 position-relative padding5'">
						<img src="../assets/img/webdesign.jpg" draggable="false" class="img-fluid">
						<div class="service-container text-white text-center">
							<div class="service-text">
								<h2 class="abril">{{ $t("services.web_title") }}</h2>
								<p>{{ $t("services.web_text") }}<br>{{ $t("services.web_text2") }}</p>
								<a href="#web" class="border-link text-white white-border btn-animation">{{ $t("services.more") }}</a>
							</div>
						</div>
					</div>
				</div>
				<a class="carousel-control-prev d-block d-md-none" href="#carouselExampleControls" role="button" data-slide="prev">
			    	<span class="carousel-control-prev-icon" aria-hidden="true"></span>
			    	<span class="sr-only">Previous</span>
			 	</a>
			  	<a class="carousel-control-next d-block d-md-none" href="#carouselExampleControls" role="button" data-slide="next">
			    	<span class="carousel-control-next-icon" aria-hidden="true"></span>
			    	<span class="sr-only">Next</span>
			  	</a>
			</div>
		</div>
		<div class="container-fluid">
			<div class="row">
				<div class="col-12 text-center">
					<h2 class="abril font-40 margin-b-40">{{ $t("other.more_info") }}</h2>
				</div>
				<div class="col-lg-7 col-12 order-2 order-lg-1 padding80 bg-darkblue">
					<div class="col-md-10 col-12 offset-md-1 text-white">
						<div style="padding: 10px;">
							<p>{{ $t("branding.first") }}</p>
							<p>{{ $t("branding.sec") }}</p>
							<p>{{ $t("branding.third") }}</p>
							<a href="#contact" class="border-link text-white white-border btn-animation--bluebg">{{ $t("other.offer") }}</a>
						</div>
					</div>
				</div>
				<div class="col-lg-5 col-12 bg-cover order-lg-2 order-1" id="branding">
					<div class="col-12 text-center text-white position-relative" style="top: 106px;" >
						<h2 class="abril font-93">{{ $t("branding.title") }}</h2>
					</div>
				</div>
			</div>
		</div>
		<div class="container-fluid">
			<div class="row">
				<div class="col-lg-5 col-12 bg-cover" id="movie">
					<div class="col-12 text-center text-white position-relative" style="top: 142px;">
						<h2 class="abril font-93">{{ $t("movie.title") }}</h2>
					</div>
				</div>
				<div class="col-lg-7 col-12 padding80">
					<div class="col-md-10 col-12 offset-md-1 text-black">
						<div style="padding: 10px;">
							<p>{{ $t("movie.first") }}</p>
							<p>{{ $t("movie.sec") }}</p>
							<p>{{ $t("movie.third") }}</p>
							<a href="#contact" class="border-link text-black black-border btn-animation">{{ $t("other.offer") }}</a>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="container-fluid">
			<div class="row">
				<div class="col-lg-7 col-12 order-lg-1 order-2 padding80 bg-darkblue">
					<div class="col-md-10 col-12 offset-md-1 text-white">
						<div style="padding: 10px;">
							<p>{{ $t("social.first") }}</p>
							<p>{{ $t("social.sec") }}</p>
							<p>{{ $t("social.third") }}</p>
							<a href="#contact" class="border-link text-white white-border btn-animation--bluebg">{{ $t("other.offer") }}</a>
						</div>
					</div>
				</div>
				<div class="col-lg-5 col-12 bg-cover order-lg-2 order-1" id="social">
					<div class="col-12 text-center text-white position-relative" style="top: 98px;" >
						<h2 class="abril font-93">{{ $t("social.title") }}</h2>
					</div>
				</div>
			</div>
		</div>
		<div class="container-fluid">
			<div class="row">
				<div class="col-lg-5 col-12 bg-cover" id="web">
					<div class="col-12 text-center text-white position-relative" style="top: 113px;">
						<h2 class="abril font-93">{{ $t("webdesign.title") }}</h2>
					</div>
				</div>
				<div class="col-lg-7 col-12 padding80">
					<div class="col-md-10 col-12 offset-md-1 text-black">
						<div style="padding: 10px;">
							<p>{{ $t("webdesign.first") }}</p>
							<p>{{ $t("webdesign.sec") }}</p>
							<p>{{ $t("webdesign.third") }}</p>
							<a href="#contact" class="border-link text-black black-border btn-animation">{{ $t("other.offer") }}</a>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="container padding80" id="references">
			<div class="row">
				<div class="col-12 text-center">
					<h2 class="abril font-40 margin-b-40">{{ $t("other.ref") }}</h2>
				</div>
				<div class="col-6 col-md-4 padding5">
					<a href="https://vimeo.com/215902161" target="_blank">
						<img src="../assets/img/mester.jpg" draggable="false" class="img-fluid ref-img">
					</a>
				</div>
				<div class="col-6 col-md-4 padding5">
					<a href="https://www.tunderujjak.hu/" target="_blank">
						<img src="../assets/img/tunder.jpg" draggable="false" class="img-fluid ref-img">
					</a>
				</div>
				<div class="col-6 col-md-4 padding5">
					<a href="https://www.youtube.com/watch?v=oJdE1k8-d_Y" target="_blank">
						<img src="../assets/img/palermo.jpg" draggable="false" class="img-fluid ref-img">
					</a>
				</div>
				<div class="col-6 col-md-4 padding5">
					<a href="https://www.facebook.com/tunderujjak.kft/" target="_blank">
						<img src="../assets/img/tunderujjak.jpg" draggable="false" class="img-fluid ref-img">
					</a>
				</div>
				<div class="col-6 col-md-4 padding5">
					<a href="https://www.youtube.com/watch?v=LcZlzFS1X8M&t=39s" target="_blank">
						<img src="../assets/img/safari.jpg" draggable="false" class="img-fluid ref-img">
					</a>
				</div>
				<div class="col-6 col-md-4 padding5">
					<a href="http://atregconsulting.com/" target="_blank">
						<img src="../assets/img/atreg.jpg" draggable="false" class="img-fluid ref-img">
					</a>
				</div>
			</div>
		</div>
		<div id="contact" class="bg-cover">
			<div class="container text-white padding80">
				<div class="row">
					<div v-bind:class="langHU ? 'd-block col-md-8 offset-md-2' : 'd-none'">
						<iframe scrolling="no" src="https://docs.google.com/forms/d/e/1FAIpQLSdB-tw8wfZ0FqXry6IqVINjMKLysgHKvIHM8dMHgULoYRk6yg/viewform?embedded=true" width="100%" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
					</div>
					<div v-bind:class="langHU ? 'd-none' : 'd-block col-md-8 offset-md-2'">
						<iframe scrolling="no" src="https://docs.google.com/forms/d/e/1FAIpQLSfKd3bXW4uqdlCMwYCY-NNgisNlmoJFuw_NppfC3leIXiryzA/viewform?embedded=true" width="100%" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	
	import { Bus } from "./../bus.js";

	export default {
		data() {
	        return {
	            lang: '',
	            langHU: true,
	            isMobile: null
	        };
	    },
		created(){
			this.lang = this.$i18n.locale;
			if(window.innerWidth < 576){
				this.isMobile = true;
			}else{
				this.isMobile = false;
			}

			window.addEventListener("resize", this.checkWindowSize);
		},
		destroyed() {
		  	window.removeEventListener("resize", this.checkWindowSize);
		},
		mounted: function(){
            var self = this;
            Bus.$on("lang", (lang) => {
                if(lang == 'hu'){
                    self.lang = "hu";
                    this.langHU = true;
                }else{
                    self.lang = "en";
                    this.langHU = false;
                }
            });
        },
        methods: {
        	checkWindowSize: function(){
        		if(window.innerWidth < 576){
					this.isMobile = true;
				}else{
					this.isMobile = false;
				}
        	}
        }
	};
</script>


// WEBPACK FOOTER //
// src/components/Main.vue